import { render, staticRenderFns } from "./EditUserModal.vue?vue&type=template&id=b8da996c&"
import script from "./EditUserModal.vue?vue&type=script&lang=js&"
export * from "./EditUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports